/**
 * User Preferences API — per-user settings persistence.
 * GET  /bot/api/user/preferences  → fetch all preferences
 * PUT  /bot/api/user/preferences  → merge-update preferences
 */

import { getBaseUrl, buildUrl, parseJson } from './utils.js';
import { getAuthHeaders } from './auth';

/**
 * Fetch the current user's preferences.
 * @returns {Promise<object>} preferences object (or empty {})
 */
export async function getPreferences() {
  const url = buildUrl(getBaseUrl(), 'bot/api/user/preferences');
  const res = await fetch(url, {
    method: 'GET',
    headers: { Accept: 'application/json', ...getAuthHeaders() },
  });
  return parseJson(res);
}

/**
 * Merge-update preferences. Only the keys provided are changed;
 * existing keys not in the payload are preserved.
 * @param {object} partial — keys to merge (e.g. { conversationFilters: {...} })
 * @returns {Promise<object>} full updated preferences
 */
export async function updatePreferences(partial) {
  const url = buildUrl(getBaseUrl(), 'bot/api/user/preferences');
  const res = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify(partial),
  });
  return parseJson(res);
}
